import { Component, ojs, app, state, v } from "modular-openscriptjs";
import {
	pageInfo,
	scrollToTop,
	empty,
	tab,
	eParse,
	either,
} from "../../../helpers";
import { dom } from "../../../fotastart";
import { api, PAGES } from "../../../declarations";
import { routes } from "../../../backendRoutes";

// Components
import MainProductView from "../../Views/MainProductView";
import MainErrandView from "../Errands/MainErrandView";
import RelatedProducts from "./RelatedProducts";
import CommentView from "../../Views/CommentView";
import CommentRepliesView from "../../Views/CommentRepliesView";
import Tabs from "../../Blocks/Tabs";
import InfiniteScroll from "../../Blocks/InfiniteScroll";
import Fab from "../../Blocks/Fab";
import SearchIconBtn from "../../Blocks/SearchIconBtn";

const h = app("h");
const route = app("router");
const $e = app("$e");

ojs(
	MainProductView,
	MainErrandView,
	RelatedProducts,
	CommentView,
	Tabs,
	InfiniteScroll,
	Fab,
	SearchIconBtn,
	CommentRepliesView
);

export default class SingleProduct extends Component {
	product = state(null);
	commentsPage = 0;

	render(...args) {
		pageInfo(PAGES.VIEW_PRODUCT);
		scrollToTop();

		if (this.product == null) this.product = state(null);
		this.commentsPage = 0;

		this.getProduct(route.params.productId);

		return h.div(
			{
				class: "py-md-5 mx-auto w-100 container-xxl px-0",
				style: "margin-bottom: 100px;",
			},

			// Product Container
			h.div(
				{ class: "mb-3" },
				v(this.product, (product) => {
					if (empty(product.value)) return null;

					return either(
						product.item_type != "errand",
						() =>
							h.MainProductView(this.product, {
								class: "p-0",
							}),
						() =>
							h.MainErrandView(this.product, {
								class: "bg-white p-0 rounded-4 shadow-sm",
							})
					);
				})
			),

			// Tabs Container
			h.div(
				{ class: "bg-white rounded-4 shadow-sm mt-3", hook: "sp-extra-info" },
				h.Tabs({
					holders: {
						nav: h.div({
							class: "nav nav-tabs nav-fill border-bottom stick-top bg-white",
							style: "z-index: 10;",
						}),
						body: h.div({ class: "tab-content p-3" }),
					},
					tabs: [
						tab(
							h.button(
								{
									class: "nav-link active d-none border-0 py-3 fw-bold small text-uppercase",
									hook: "sp-related-products",
								},
								h.span("Related")
							),
							h.div(
								{
									class: "tab-pane fade show active d-none",
									hook: "sp-related-products",
								},
								h.section(
									h.p(
										{
											class: "fw-bold mb-3 text-secondary small text-uppercase letter-spacing-1",
										},
										"People also bought"
									),
									h.RelatedProducts(this.product)
								)
							)
						),
						tab(
							h.button(
								{
									class: "nav-link d-none border-0 py-3 fw-bold small text-uppercase",
									hook: "sp-product-comments",
								},
								h.span("Comments")
							),
							h.div(
								{
									class: "tab-pane fade d-none",
									hook: "sp-product-comments",
								},
								h.InfiniteScroll({
									child: h.div(
										{
											class: "d-flex flex-column gap-3",
										},
										h.div({
											id: `c-single-product-comments`,
											class: "d-flex flex-column gap-3",
										})
									),
									callback: (entries, observer, marker) => {
										entries.forEach((entry) => {
											if (!entry.isIntersecting) return;
											this.getComments(
												marker,
												`c-single-product-comments`
											);
										});
									},
								})
							)
						),
					],
				})
			),

			// Floating Action Buttons
			h.Fab([
				h.SearchIconBtn({ class: "bg-white shadow-sm text-dark" }),
				h.button(
					{
						class: "btn btn-dark shadow-lg rounded-circle d-flex align-items-center justify-content-center",
						style: "width: 50px; height: 50px;",
						onclick: h.func("fireEvent", $e.app.needs.orderOptions),
					},
					h.i({ class: "fa-solid fa-pen" })
				),
			]),
			...args
		);
	}

	async getComments(marker, holderId) {
		this.commentsPage++;
		let page = this.commentsPage;

		let spinner = h.Spinner({
			class: "p-3",
			parent: marker,
			resetParent: true,
		});

		let res = await api.get(
			`${routes.customerProducts}/${this.product?.id}/comments`,
			{ page },
			{ silent: true }
		);

		if (res) {
			let comments = res.data.comments.data;

			for (let comment of comments) {
				let id = `c-${comment?.id}`;
				let rendered = false;

				if (dom.get(`[sp-comment-id="${id}"]`, dom.id(holderId))) {
					rendered = true;
				}

				if (!rendered) {
					h.CommentView(comment, {
						class: "bg-light rounded-3 p-3 border border-light-subtle",
						parent: dom.id(holderId),
						$sp_comment_id: id,
					});
					h.div(
						{
							class: "d-flex d-none mt-2",
							parent: dom.id(holderId),
							sp_comment_replies_holder: `c-${comment.id}`,
						},
						h.div({
							style: "width: 2px;",
							class: "bg-secondary-subtle mx-2 rounded",
						}),
						h.CommentRepliesView(comment, {
							class: "flex-fill d-flex flex-column gap-2",
						})
					);
				}
			}

			if (!comments?.length && this.commentsPage == 1) {
				h.div(
					{
						parent: dom.id(holderId),
						resetParent: true,
						class: "text-secondary fst-italic text-center py-4",
						id: "vp-no-comment-found",
					},
					"No comments yet."
				);
			}

			if (!comments?.length) this.commentsPage = page - 1;
			else dom.id("vp-no-comment-found")?.remove();

			this.commentsPage = res.data.comments.current_page;
		}

		spinner.remove();
	}

	async getProduct(productId) {
		let res = await api.get(`${routes.customerProducts}/${productId}`, {
			user: route.qs.get("u"),
		});

		if (!res) return;

		this.product.value = res.data.product;
		this.emit("productAvailable");
	}

	$_productAvailable() {
		if (!empty(this.product.comment_count)) {
			dom.all(`[hook="sp-product-comments"]`)?.forEach((e) =>
				e.classList.remove("d-none")
			);
		}
	}

	cleanUp() {
		super.cleanUp();
		this.product = null;
		this.commentsPage = 0;
	}

	$$product = {
		stored: (ed, event) => this.updateProduct(ed, event),
		is: {
			liked_unliked_bookmarked_notBookmarked_commented: (ed, event) => {
				this.updateProduct(ed, event);
				this.updateProductCommentList(ed, event);
			},
		},
	};

	$$app = {
		messages: {
			noRelatedProducts: () => {
				dom.all(`[hook="sp-related-products"]`)?.forEach((e) =>
					e.classList.add("d-none")
				);
				dom.all(`[hook="sp-product-comments"]`)?.forEach((e) =>
					e.classList.add("active", "show")
				);
			},
			relatedProductsFound: () => {
				dom.all(`[hook="sp-related-products"]`)?.forEach((e) =>
					e.classList.remove("d-none")
				);
				dom.all(`[hook="sp-product-comments"]`)?.forEach((e) =>
					e.classList.remove("active", "show")
				);
			},
		},
	};

	updateProductCommentList(ed, event) {
		if (!route.is("product.view-product")) return;
		if (event != $e.product.is.commented) return;

		let { comment } = eParse(ed).message;
		let holderId = "c-single-product-comments";
		let id = `c-${comment.id}`;

		h.div(
			{
				class: "d-flex d-none mt-2",
				parent: dom.id(holderId),
				sp_comment_replies_holder: `c-${comment.id}`,
				firstOfParent: true,
			},
			h.div({
				style: "width: 2px;",
				class: "bg-secondary-subtle mx-2 rounded",
			}),
			h.CommentRepliesView(comment, {
				class: "flex-fill d-flex flex-column gap-2",
			})
		);
		h.CommentView(comment, {
			class: "bg-light rounded-3 p-3 border border-light-subtle",
			parent: dom.id(holderId),
			firstOfParent: true,
			$sp_comment_id: id,
		});
	}

	updateProduct(ed, event) {
		if (!route.is("product.view-product")) return;

		const { message } = eParse(ed);
		const product = message.get("product");

		if (this.product.id !== product.id) return;
		this.product.value = product;
	}

	$$comment = {
		deleted: (ed, event) => {
			let { comment } = eParse(ed).message;
			dom.get(`[sp-comment-id="c-${comment?.id}"]`)?.remove();
			dom.get(`[sp-comments-children-for="c-${comment?.id}"]`)?.remove();
		},
		is: {
			liked_unliked_repliedTo: (ed, event) => {
				this.updateComment(ed, event);
			},
		},
		needs: {
			replies: (ed, event) => this.showReplies(ed, event),

			to: {
				hideReplies: (ed, event) => this.hideReplies(ed, event),
			},
		},
	};

	hideReplies(ed, event) {
		let { comment } = eParse(ed).message;
		let holder = dom.get(`[sp-comment-replies-holder="c-${comment.id}"]`);
		if (!holder) return;
		holder.classList.add("d-none");
	}

	async showReplies(ed, event) {
		let { comment } = eParse(ed).message;
		let holder = dom.get(`[sp-comment-replies-holder="c-${comment.id}"]`);
		if (!holder) return;
		holder.classList.remove("d-none");
	}

	updateComment(ed, event) {
		let { comment } = eParse(ed).message;
		let parent = dom.get(`[sp-comment-id="c-${comment?.id}"]`);

		if (!parent) return;

		let id = `c-${comment?.id}`;

		h.CommentView(comment, {
			class: "bg-light rounded-3 p-3 border border-light-subtle",
			parent,
			replaceParent: true,
			$sp_comment_id: id,
		});
	}
}
